import CardProgressGoalsNR from "./CardProgressGoalsNR"
export default CardProgressGoalsNR